import { createContext } from 'react';

export const ModifierContext = createContext();
